import { useHRM2120_R01Store } from './Store_HRM2120_R01';

/** 월요일부터 시작하는 달력의 요일 제목이다. */
const WEEKDAYS = ['월', '화', '수', '목', '금', '토', '일'];
/** 달력 셀과 범례에서 같은 크기와 정렬을 사용하는 근무조 표시 스타일이다. */
const SHIFT_BADGE_BASE_CLASS = 'inline-flex min-w-[64px] items-center justify-center whitespace-nowrap rounded-md border px-1.5 py-0.5 font-medium leading-4';
/** 주간과 야간을 사원 목록의 근무조 색상과 같은 계열로 구분한다. */
const DAY_BADGE_CLASS = `${SHIFT_BADGE_BASE_CLASS} border-amber-300 bg-amber-100 text-amber-800`;
const NIGHT_BADGE_CLASS = `${SHIFT_BADGE_BASE_CLASS} border-indigo-300 bg-indigo-100 text-indigo-800`;

/** 저장된 배정을 기준으로 계산한 5주 달력을 표시한다. */
export const Calendar_HRM2120_R01 = () => {
    const { HRM2120_R01CalendarList, selectedHRM2120_R01, HRM2120_R01PastFilter } = useHRM2120_R01Store();
    return (
        <section className="flex flex-col h-full min-h-0 border rounded bg-white">
            <div className="flex items-center justify-between p-2 border-b">
                <strong>근무 달력 (5주)</strong>
                <span className="flex items-center gap-2 text-xs text-gray-500">
                    <span className={DAY_BADGE_CLASS}>주간 근무</span>
                    <span className={NIGHT_BADGE_CLASS}>야간 근무</span>
                    <span>· 토·일 휴무 · 저장된 배정 기준</span>
                </span>
            </div>
            <div className="grid grid-cols-7 text-center bg-gray-50 border-b">
                {WEEKDAYS.map(day => (
                    <div key={day} className="py-1 text-sm">{day}</div>
                ))}
            </div>
            {/* 다섯 주 날짜 셀은 달력 영역 높이의 절반만 사용한다. */}
            <div className="grid grid-cols-7 grid-rows-5 h-1/2 shrink-0">
                {selectedHRM2120_R01 && HRM2120_R01CalendarList.map(row => {
                    const date = new Date(`${row.workDt}T00:00:00`);
                    const isWeekend = date.getDay() === 0 || date.getDay() === 6;
                    const selectedDateClass = row.workDt === HRM2120_R01PastFilter.baseDt
                        ? 'ring-2 ring-blue-400 ring-inset'
                        : '';
                    const shiftBadgeClass = row.isNightShift ? NIGHT_BADGE_CLASS : DAY_BADGE_CLASS;

                    /** 날짜는 왼쪽, 근무 상태 또는 휴무는 오른쪽에 한 줄로 배치한다. */
                    return (
                        <div
                            key={row.workDt}
                            className={`flex items-center justify-between gap-1 border-b border-r p-1 text-xs ${selectedDateClass}`}
                        >
                            <div className="whitespace-nowrap">
                                {date.getMonth() + 1}/{date.getDate()}
                            </div>
                            {isWeekend ? (
                                <span className="inline-flex min-w-[64px] justify-center text-gray-400">휴무</span>
                            ) : row.shiftNm ? (
                                <span className={shiftBadgeClass}>
                                    {row.shiftNm}
                                </span>
                            ) : null}
                        </div>
                    );
                })}
            </div>
        </section>
    );
};
